import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo_menu_black.png";

class ReinscripcionCitados extends Component {
    state = {  }

    contenido = () => {
        let { datos } = this.props;
        const styles = StyleSheet.create(ADMISION[0]);

        let nombre = (nombre) => {
            if (nombre === null) return "";
            return nombre;
        }

        let fecha = () => {
            if (datos.length === 0) return "No disponible"
            let f = (datos[0].fecha_cita).split("/");
            let meses = {
                "01": "Enero",
                "02": "Febrero",
                "03": "Marzo",
                "04": "Abril",
                "05": "Mayo",
                "06": "Junio",
                "07": "Julio",
                "08": "Agosto",
                "09": "Septiembre",
                "10": "Octubre",
                "11": "Noviembre",
                "12": "Diciembre"
            }
            return `${f[0]} de ${meses[f[1]]} de ${f[2]}`
        }

        let estudiantes = () => {
            if (datos.length === 0) return (
                <View style={[styles.row]}>
                    <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen estudiantes</Text>
                </View>
            )

            return (
                datos.map(option => (
                    <View key={option.id} style={[styles.row]}>
                        <Text style={[styles.colTablaList3, styles.font9, styles.bordeCol11, styles.borderTop, styles.center]}>{`${option.nacionalidad} ${option.ci}`}</Text>
                        <Text style={[styles.colTablaList1, styles.font9, styles.bordeCol9, styles.borderTop]}>{`${option.nombre_1} ${nombre(option.nombre_2)} ${option.apellido_1}  ${nombre(option.apellido_2)}`}</Text>
                        <Text style={[styles.colTablaList4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{option.fecha_solicitud}</Text>
                        <Text style={[styles.colTablaList4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{option.fecha_cita}</Text>
                    </View>
                ))
            )
        }

        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    REINSCRIPCION - LISTADO DE ESTUDIANTES CITADOS
                </Text>
                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DATOS ESTADÍSTICOS</Text>
                    <View style={[styles.row, {padding: 5, backgroundColor: "#fff"}]}>
                        <Text style={[styles.col3, styles.font9, {textAlign: "justify"}]}>
                            Total de Estudiantes Citados para la fecha: {datos.length}
                        </Text>
                        <Text style={[styles.col3, styles.font9, {textAlign: "right", color: "#c60000"}]}>
                            Fecha: {fecha()}
                        </Text>
                    </View>
                </View>
                <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF",}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. LISTADO DE ESTUDIANTES</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaList3, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>Cedula</Text>
                            <Text style={[styles.colTablaList1, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Estudiantes</Text>
                            <Text style={[styles.colTablaList4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Fecha de Solicitud</Text>
                            <Text style={[styles.colTablaList4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Fecha Cita</Text>
                        </View>
                        {estudiantes()}
                    </View>
                </View>
                <View style={[styles.footer]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col6]}>
                        <Text style={[styles.linea3]}></Text>
                            <Text style={[styles.encabezado2]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }
    
    render() { 
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title="Listado de Estudiantes Citados">
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido()}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default ReinscripcionCitados;


// WEBPACK FOOTER //
// ./src/components/Reportes/ReinscripcionCitados.jsx